export default __webpack_public_path__ + "static/media/auth-blue-card.21877993.svg";